/** ------------------------------------------------------------------------- *
 * JavaScript Modules *
 * -------------------------------------------------------------------------- *
 */

/* global CHART_ARR */

import Animate from './modules/animate';
import Dropdown from './modules/dropdown';
import Tables from './modules/tables';
import Toggle from './modules/toggle';
import StickyNav from './modules/sticky-nav';
import Slider from './modules/slider';
import Charts from './modules/charts';

/** -------------------- *
 * Module Initialization *
 * --------------------- *
 */

// Initialize on all pages for navigation
StickyNav.init();
Toggle.init();

// Initialize if required
if (document.querySelector(Dropdown.selector) !== null) {
    Dropdown.init();
}

// Initialize if required
if (document.querySelector(Animate.selector) !== null) {
    Animate.init();
}

// Initialize if required
if (document.querySelector(Tables.selector) !== null) {
    Tables.init();
}

// Initialize if required
if (document.querySelector(Slider.selector) !== null) {
    Slider.init();
}

// Initialize if required
if (typeof CHART_ARR !== 'undefined' && CHART_ARR.length > 0) {
    Charts.init();
}
